module.exports = __webpack_public_path__ + "static/img/1-4.9870703.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/1-4.png
// module id = 5lvS
// module chunks = 0